var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({staticClass:"duration-1000 delay-inherited translate-y-8 opacity-0",class:{
    'transition-all opacity-100 transform-none': _vm.inView,
  }},'div',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }